export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=402fd4c7d88b0c9d80a02ca789eaa416de9cdb5dba&name=revalidateCommunity!'